import React, { useEffect, useState } from 'react';
import { getToken } from '../services/api';

// Los documentos personales ya no se sirven como estáticos públicos: se piden con el token
// de sesión y se muestran desde un blob temporal (la URL nunca queda en el historial ni en logs).
export const ProtectedImage = ({ path, alt, className, ...rest }) => {
  const [src, setSrc] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let objectUrl = null;
    let cancelado = false;
    const cargar = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}${path}`, {
          headers: { Authorization: `Bearer ${getToken()}` },
        });
        if (!res.ok) throw new Error(String(res.status));
        const blob = await res.blob();
        if (cancelado) return;
        objectUrl = URL.createObjectURL(blob);
        setSrc(objectUrl);
      } catch (e) {
        if (!cancelado) setError(true);
      }
    };
    if (path) cargar();
    return () => {
      cancelado = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [path]);

  if (error) {
    return (
      <div className="flex items-center justify-center h-full text-gray-400"
           data-testid="protected-image-error">
        <span>Error al cargar documento</span>
      </div>
    );
  }
  if (!src) {
    return (
      <div className="flex items-center justify-center h-full text-gray-400"
           data-testid="protected-image-loading">
        <span>Cargando…</span>
      </div>
    );
  }
  return <img src={src} alt={alt} className={className} data-testid="protected-image" {...rest} />;
};

export default ProtectedImage;
